import delay from 'delay';
import { useSuspenseCurrentUser } from 'FrontRoyalAngular';
import { useSuspendableResource } from 'useSuspendableResource';
import { getProgressSuspendableResource } from '../progressSuspendableResource';

export function useContentProgress() {
    const currentUser = useSuspenseCurrentUser();
    if (!currentUser) throw delay(100);
    return useSuspendableResource(getProgressSuspendableResource(currentUser.id));
}
